(function () {
  function initPdpRewardBoxes() {
    if (!window.RewardPoints) return;

    document.querySelectorAll('[data-pdp-reward-box]').forEach((box) => {
      const raysElement = box.querySelector('[data-reward-rays]');
      if (!raysElement) return;

      const price = Number(raysElement.dataset.basePrice) || 0;
      const variantId = raysElement.dataset.variantId;
      const productId = box.dataset.productId || raysElement.dataset.productId;

      window.RewardPoints.updatePdpRewardBox(box, price, variantId, productId);
    });
  }

  function refreshPdpRewardBoxes() {
    if (!window.RewardPoints) return;
    window.RewardPoints.clearCache();
    initPdpRewardBoxes();
  }

  function scheduleInit() {
    initPdpRewardBoxes();

    if (!window.RewardPoints) {
      window.addEventListener('load', initPdpRewardBoxes, { once: true });
      return;
    }

    if (window.RewardPoints.isLoggedIn()) {
      setTimeout(refreshPdpRewardBoxes, 1500);
    }
  }

  document.addEventListener('DOMContentLoaded', scheduleInit);
  window.addEventListener('renogy:login', refreshPdpRewardBoxes);
  window.refreshPdpRewardBoxes = refreshPdpRewardBoxes;
})();
